import React, { Component } from "react";

import { Row, Col, Container } from "react-bootstrap";

import { API_URL } from "../config";
class Emailstep1 extends Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // i think you are missing this
  }

  goBack() {
    this.props.history.goBack();
  }
  resend = event => {
    console.log("EMAIL");
    let verify = JSON.parse(this.props.match.params.verify);
    let temp = JSON.parse(this.props.match.params.id);
    // event.preventDefault();
    // this.setState({ sendingEmail: true });

    // Super interesting to me that you can mess within the upper and lower case
    // of the headers on the fetch call and the world does not explode.

    fetch(`${API_URL}/email`, {
      method: "post",
      mode: "cors",
      headers: {
        accept: "application/JSON",
        "content-type": "application/JSON"
      },
      body: JSON.stringify({
        email: verify.email,
        voicenumber: verify.voice,
        number: verify.number,
        emailing: temp.email,
        sms: temp.sms,
        voice: temp.voice
      })
    });
  };
  render() {
    let verifyMail = JSON.parse(this.props.match.params.verify);
    console.log(this.props.match.params);
    let temp = JSON.parse(this.props.match.params.id);
    console.log(temp);
    return (
      <React.Fragment>
        <Container fluid>
          <Row className="heading-text">
            <Container className="no-left-right-padding">
              <h1 className="Formheader" style={{ "font-size": 1.25 + "rem" }}>
                ServiceOntario reminders sign up
              </h1>
            </Container>
          </Row>
        </Container>
        <Container>
          <Row className="one-padding-top">
            <Col>
              <p className="back-btn" onClick={this.goBack}>
                Back
              </p>
            </Col>
          </Row>

          {temp.email ? (
            <Row>
              <Col>
                <Row className="head1">
                  <Col>
                    <span>Verify your email</span>
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    We sent an email to
                    <span>{" " + verifyMail.email}</span>.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    Follow the instructions in the email to verify this is your
                    email address.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>The email should arrive in 5-10 minutes.</Col>
                </Row>
                <Row className="para">
                  <Col>Haven't received the email yet?.</Col>
                </Row>

                <Row className="back-btn">
                  <Col>Resend the email</Col>
                </Row>
              </Col>
            </Row>
          ) : (
            ""
          )}
          {temp.voicesms ? (
            <Row>
              <Col>
                <Row className="head1">
                  <Col>
                    <span>Verify your phone number</span>
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    We sent an message to
                    <span>{" " + verifyMail.number + " "}</span> and{" "}
                    <span>{" " + verifyMail.voice + " "}</span>.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    Follow the instructions in the message to verify your
                    contact information.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>The message should arrive in 5-10 minutes.</Col>
                </Row>
                <Row className="para">
                  <Col>Haven't received the message yet?.</Col>
                </Row>

                <Row className="back-btn">
                  <Col>Resend the message</Col>
                </Row>
              </Col>
            </Row>
          ) : (
            ""
          )}
          {temp.emailvoice ? (
            <Row>
              <Col>
                <Row className="head1">
                  <Col>
                    <span>Verify your email and phone number</span>
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    We sent an message to
                    <span>{" " + verifyMail.email + " "}</span> and{" "}
                    <span>{" " + verifyMail.voice + " "}</span>.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    Follow the instructions in the message to verify your
                    contact information.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>The message should arrive in 5-10 minutes.</Col>
                </Row>
                <Row className="para">
                  <Col>Haven't received the message yet?.</Col>
                </Row>

                <Row className="back-btn">
                  <Col>Resend the message</Col>
                </Row>
              </Col>
            </Row>
          ) : (
            ""
          )}
          {temp.smsemail ? (
            <Row>
              <Col>
                <Row className="head1">
                  <Col>
                    <span>Verify your email and phone number</span>
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    We sent an email and text message to
                    <span>{" " + verifyMail.email + " "}</span> and{" "}
                    <span>{" " + verifyMail.number + " "}</span>.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    Follow the instructions in the email and text to verify your
                    contact information.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>The email and text should arrive in 5-10 minutes.</Col>
                </Row>
                <Row className="para">
                  <Col>Haven't received the email yet?.</Col>
                </Row>

                <Row className="back-btn">
                  <Col>Resend the email</Col>
                </Row>
                <Row className="para">
                  <Col>Haven't received the text message yet?.</Col>
                </Row>

                <Row className="back-btn">
                  <Col>Resend the text</Col>
                </Row>
              </Col>
            </Row>
          ) : (
            ""
          )}
          {temp.all ? (
            <Row>
              <Col>
                <Row className="head1">
                  <Col>
                    <span>Verify your contact method</span>
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    We sent an message to{" "}
                    <span>{" " + verifyMail.email + ", "}</span>
                    <span>{" " + verifyMail.number + " "}</span> and{" "}
                    <span>{" " + verifyMail.voice + " "}</span>.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    Follow the instructions in the message to verify your
                    contact information.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>The message should arrive in 5-10 minutes.</Col>
                </Row>
                <Row className="para">
                  <Col>Haven't received the message yet?.</Col>
                </Row>

                <Row className="back-btn">
                  <Col>Resend the message</Col>
                </Row>
              </Col>
            </Row>
          ) : (
            ""
          )}
          {temp.voice ? (
            <Row>
              <Col>
                <Row className="head1">
                  <Col>
                    <span>Verify your phone number</span>
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    We are calling
                    <span>{" " + verifyMail.voice}</span>.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    Follow the instructions in the message to confirm your
                    reminders.
                  </Col>
                </Row>

                <Row className="para">
                  <Col>Haven't received the call yet?.</Col>
                </Row>

                <Row className="back-btn">
                  <Col>Request another call</Col>
                </Row>
              </Col>
            </Row>
          ) : (
            ""
          )}
          {temp.sms ? (
            <Row>
              <Col>
                <Row className="head1">
                  <Col>
                    <span>Verify your phone number</span>
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    We sent a text message to your phone number
                    <span>{" " + verifyMail.number}</span>.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>
                    Follow the instructions in the text to verify this is your
                    phone number.
                  </Col>
                </Row>
                <Row className="para">
                  <Col>The text should arrive in 5-10 minutes.</Col>
                </Row>
                <Row className="para">
                  <Col>Haven't received the text message yet?.</Col>
                </Row>

                <Row className="back-btn">
                  <Col>Resend the text</Col>
                </Row>
              </Col>
            </Row>
          ) : (
            ""
          )}
        </Container>
      </React.Fragment>
    );
  }
}
export default Emailstep1;
